import {
  LABEL_BOTTOM_PADDING,
  LABEL_FIRST_LINE_OFFSET,
  LABEL_LINE_HEIGHT,
  LABEL_MAX_LINES,
  LABEL_WRAP_WIDTH,
} from "./constants";
import type { BarChartDatum } from "./types";

export const wrapLabel = (label: string): string[] => {
  const words = label.split(" ");
  const lines: string[] = [];
  let current = "";

  for (const word of words) {
    const candidate = current ? `${current} ${word}` : word;
    if (candidate.length > LABEL_WRAP_WIDTH && current) {
      lines.push(current);
      current = word;
    } else {
      current = candidate;
    }
  }
  if (current) {
    lines.push(current);
  }

  return lines.slice(0, LABEL_MAX_LINES);
};

export const getBottomMargin = (data: BarChartDatum[]) => {
  const maxLines = Math.max(1, ...data.map((d) => wrapLabel(d.label).length));
  return (
    LABEL_FIRST_LINE_OFFSET +
    (maxLines - 1) * LABEL_LINE_HEIGHT +
    LABEL_BOTTOM_PADDING
  );
};
